import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_126_add_purchase_return_voucher: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Purchase return voucher",

    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "pur_ret_add",
        TableName: "purchase_return",
        DisplayName: "purchase_return",
        columnNumber: "m1 t1 w1",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        Fields: [
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "Purchase return details",
            BindValue: "purch_return_details",
            style: {
              direction: FlexDirection.COLUMN,
            },
            childComponents: [
              {
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                name: "drp_purchase_ret",
                label: "Purchase No.",
                placeholder: "",
                required: true,
                lookupName: "purchase_datas",
                options: [],
                searchable: true,
                clearable: true,
                Json_Attribute: "purchase_id",
                IsVerticalView: true,
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Purchase No. is required",
                  },
                ],
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_purchaseno",
                label: "Return No.",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                disabled: true,
                Json_Attribute: "purchase_return_no",
                AutoPopulate: true,
                AutoPopulate_format: "PURRET_[******]",
                IsVerticalView: true,
              },
              {
                componentType: ComponentType.DATE_FIELD,
                name: "txt_Purchase_date",
                label: "Date",
                placeholder: "",
                required: true,
                Json_Attribute: "purchase_retrun_date",
                IsVerticalView: true,
                DefaultToday: true, // Auto-populate with current date
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Date is required",
                  },
                ],
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_mobile",
                label: "Mobile",
                placeholder: "",
                required: false,
                inputType: InputType.PHONE,
                disabled: false,
                maxLength: 10,
                Json_Attribute: "mobile_no",
                BindParent: {
                  drp_purchase_ret: "mobile_no",
                },
                IsVerticalView: true,
                validation: [
                  {
                    rule: ValidationRule.PATTERN,
                    value: "^[0-9]*$",
                    message: "Only numbers are allowed",
                  },
                ],
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_vendor_taxregno",
                label: "TRN.",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                disabled: false,
                Json_Attribute: "vendor_taxregno",
                BindParent: {
                  drp_purchase_ret: "taxregno",
                },
                IsVerticalView: true,
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_vendor_name",
                label: "Vendor name",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                disabled: true,
                Json_Attribute: "",
                BindParent: {
                  drp_purchase_ret: "sname",
                },
                IsVerticalView: true,
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_vendor_refno",
                label: "Vendor Ref No.",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                disabled: false,
                Json_Attribute: "vendor_refno",
                IsVerticalView: true,
              },
              {
                componentType: ComponentType.DATE_FIELD,
                name: "txt_Purchase_ref_date",
                label: "Ref date",
                placeholder: "",
                DefaultToday: true,
                required: false,
                Json_Attribute: "ref_date",
                IsVerticalView: true,
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_fax",
                label: "Fax",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                disabled: false,
                Json_Attribute: "fax",
                BindParent: {
                  drp_purchase_ret: "fax",
                },
                IsVerticalView: true,
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_remarks",
                label: "Remarks",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                disabled: false,
                Json_Attribute: "remarks",
                IsVerticalView: true,
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_to_ledger",
                label: "To ledger",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                disabled: true,
                Json_Attribute: "to_ledger_posting",
                BindParent: {
                  drp_purchase_ret: "payment_mode",
                },
                IsVerticalView: true,
              },
              {
                componentType: ComponentType.SELECT_DROPDOWN,
                name: "drp_purch_return_type",
                label: "Return type",
                placeholder: "",
                required: true,
                lookupName: "get_ledger_for_puchase_return",
                options: [],
                Json_Attribute: "purchase_return_type",
                IsVerticalView: true,
                BindParent: {
                  drp_purchase_ret: "purchase_type",
                },
                validation: [
                  {
                    rule: ValidationRule.REQUIRED,
                    message: "Return type is required",
                  },
                ],
              },
              {
                componentType: ComponentType.CHECKBOX,
                name: "chk_add_to_unadjusted",
                label: "Add to Unadjusted Entries",
                Json_Attribute: "is_draft",
                IsVerticalView: true,
                defaultValue: "0",
              },
            ],
          },
          {
            componentType: ComponentType.SUB_MODULE,
            name: "purchase_return_details",
            label: "Purchase return details",
            tableName: "purchase_return_details",
            lookupName: "purchase_details",
            BindValue: "purchase_return_details",
            parentField: "drp_purchase_ret",
            DisableAddNewRow:true,
            childControls: [
              {
                componentType: ComponentType.SELECT_DROPDOWN,
                name: "drp_product",
                label: "Code",
                placeholder: "",
                required: false,
                lookupName: "product_itemcode",
                options: [],
                Json_Attribute: "product_id",
                BindValue: "drp_product",
                disabled: true,
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_itemname",
                label: "Item name",
                placeholder: "",
                required: false,
                inputType: InputType.TEXT,
                disabled: true,
                Json_Attribute: "item_name",
                BindValue: "txt_itemname",
                BindParent: {
                  drp_product: "item_name",
                },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_rate",
                label: "Rate",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                disabled: false,
                Json_Attribute: "rate",
                BindValue: "txt_rate",
                ExpressionV2: "[drp_product.purchase_rate]",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_inv_qty",
                label: "Qty",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                disabled: true,
                excludeFromSave: true,
                BindValue: "txt_inv_qty",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_qty",
                label: "Return qty",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                Json_Attribute: "qty",
                BindValue: "txt_qty",
                validation: [
                  {
                    rule: ValidationRule.PATTERN,
                    value: "^[0-9]*$",
                    message: "Only numbers are allowed",
                  },
                  {
                    rule: ValidationRule.CONDITION,
                    condition: "[qty] <= [inv_qty]",
                    message: "Return quantity cannot be greater than purchase quantity",
                  },
                ],
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_amount",
                label: "Amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                disabled: true,
                Json_Attribute: "amount",
                BindValue: "txt_amount",
                ExpressionV2: "[txt_rate] * [txt_qty]",
              },
              {
                componentType: ComponentType.SELECT_DROPDOWN,
                name: "drp_vat",
                label: "VAT%",
                placeholder: "",
                required: false,
                lookupName: "tax_rates",
                options: [],
                defaultValue: "5%",
                Json_Attribute: "vat_id",
                BindValue: "drp_vat",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_vat_amt",
                label: "Vat amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                disabled: true,
                Json_Attribute: "vat_amt",
                BindValue: "txt_vat_amt",
                ExpressionV2: "[txt_amount] * ([drp_vat.taxrate]/100)",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                name: "txt_net_amt",
                label: "Net amount",
                placeholder: "",
                required: false,
                inputType: InputType.NUMBER,
                defaultValue: "0",
                disabled: true,
                Json_Attribute: "net_amt",
                BindValue: "txt_net_amt",
                ExpressionV2: "[txt_amount] + [txt_vat_amt]",
              },
            ],
            FooterControls: [
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_2",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_3",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_3",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_6",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                IncludeLabel: false,
                Label: "Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_sub_amount",
                Json_Attribute: "amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_amount]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                componentType: ComponentType.TEXT_FIELD,
                BindValue: "txt_7",
                IncludeLabel: false,
                IsReadOnly: true,
                style: { display: "none" },
              },
              {
                IncludeLabel: false,
                Label: "VAT amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "spare_vat_amount",
                Json_Attribute: "vat_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_vat_amt]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
              {
                IncludeLabel: false,
                Label: "Amount",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_sub_net_amount",
                Json_Attribute: "net_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                ExpressionV2: "[SUM:txt_net_amt]",
                IsVerticalView: true,
                inputType: InputType.NUMBER,
                Default_Value: "0",
              },
            ],
          },
        ],
      },
      {
        componentType: ComponentType.BUTTON,
        name: "Submit",
        onPressAction: "save",
        style: {
          backgroundColor: "#22c55e",
        },
      },
    ],
  },
];
